import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { deliveryProtocolBnData, deliveryProtocolData } from '../../utils';
import { getLocaleString } from '../../utils/locales';


export const DeliveryProtocol = () => {
  const locale = getData(LANGUAGE);

  const data = locale === 'en' ? deliveryProtocolData : deliveryProtocolBnData;

  return (
    <div className="my-5 mx-5 text-justify pt-12 lg:pt-16 md:pt-16">
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <title>{getLocaleString('delivery_protocol_header', locale)}</title>
      
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: #333; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .p, p { color: #333;  font-size: 11pt; margin:0pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n #l2 {padding-left: 0pt;counter-reset: c2 1; }\n #l2> li>*:first-child:before {counter-increment: c2; content: counter(c2, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l2> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l3 {padding-left: 0pt;counter-reset: c3 1; }\n #l3> li>*:first-child:before {counter-increment: c3; content: counter(c3, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l3> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l4 {padding-left: 0pt;counter-reset: c4 1; }\n #l4> li>*:first-child:before {counter-increment: c4; content: counter(c4, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l4> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l5 {padding-left: 0pt;counter-reset: c4 1; }\n #l5> li>*:first-child:before {counter-increment: c4; content: counter(c4, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l6 {padding-left: 0pt;counter-reset: c4 1; }\n #l6> li>*:first-child:before {counter-increment: c4; content: counter(c4, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l7 {padding-left: 0pt;counter-reset: d1 1; }\n #l7> li>*:first-child:before {counter-increment: d1; content: counter(d1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l7> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n li {display: block; }\n #l8 {padding-left: 0pt;counter-reset: e1 4; }\n #l8> li>*:first-child:before {counter-increment: e1; content: counter(e1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l8> li:first-child>*:first-child:before {counter-increment: e1 0;  }\n #l9 {padding-left: 0pt;counter-reset: e2 1; }\n #l9> li>*:first-child:before {counter-increment: e2; content: counter(e2, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l9> li:first-child>*:first-child:before {counter-increment: e2 0;  }\n li {display: block; }\n #l10 {padding-left: 0pt;counter-reset: f1 1; }\n #l10> li>*:first-child:before {counter-increment: f1; content: counter(f1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l10> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n #l11 {padding-left: 0pt;counter-reset: g1 5; }\n #l11> li>*:first-child:before {counter-increment: g1; content: counter(g1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l11> li:first-child>*:first-child:before {counter-increment: g1 0;  }\n #l12 {padding-left: 0pt;counter-reset: h1 1; }\n #l12> li>*:first-child:before {counter-increment: h1; content: counter(h1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l12> li:first-child>*:first-child:before {counter-increment: h1 0;  }\n #l13 {padding-left: 0pt;counter-reset: h2 1; }\n #l13> li>*:first-child:before {counter-increment: h2; content: counter(h2, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l13> li:first-child>*:first-child:before {counter-increment: h2 0;  }\n #l14 {padding-left: 0pt;counter-reset: i1 1; }\n #l14> li>*:first-child:before {counter-increment: i1; content: counter(i1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l14> li:first-child>*:first-child:before {counter-increment: i1 0;  }\n #l15 {padding-left: 0pt;counter-reset: j1 1; }\n #l15> li>*:first-child:before {counter-increment: j1; content: counter(j1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l15> li:first-child>*:first-child:before {counter-increment: j1 0;  }\n #l16 {padding-left: 0pt;counter-reset: k1 1; }\n #l16> li>*:first-child:before {counter-increment: k1; content: counter(k1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l16> li:first-child>*:first-child:before {counter-increment: k1 0;  }\n #l17 {padding-left: 0pt;counter-reset: l1 1; }\n #l17> li>*:first-child:before {counter-increment: l1; content: counter(l1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l17> li:first-child>*:first-child:before {counter-increment: l1 0;  }\n #l18 {padding-left: 0pt;counter-reset: m1 1; }\n #l18> li>*:first-child:before {counter-increment: m1; content: counter(m1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l18> li:first-child>*:first-child:before {counter-increment: m1 0;  }\n li {display: block; }\n #l19 {padding-left: 0pt;counter-reset: n1 7; }\n #l19> li>*:first-child:before {counter-increment: n1; content: counter(n1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l19> li:first-child>*:first-child:before {counter-increment: n1 0;  }\n #l20 {padding-left: 0pt;counter-reset: o1 1; }\n #l20> li>*:first-child:before {counter-increment: o1; content: counter(o1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l20> li:first-child>*:first-child:before {counter-increment: o1 0;  }\n #l21 {padding-left: 0pt;counter-reset: p1 1; }\n #l21> li>*:first-child:before {counter-increment: p1; content: counter(p1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l21> li:first-child>*:first-child:before {counter-increment: p1 0;  }\n #l22 {padding-left: 0pt;counter-reset: o1 3; }\n #l22> li>*:first-child:before {counter-increment: o1; content: counter(o1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l22> li:first-child>*:first-child:before {counter-increment: o1 0;  }\n #l23 {padding-left: 0pt;counter-reset: q1 1; }\n #l23> li>*:first-child:before {counter-increment: q1; content: counter(q1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l23> li:first-child>*:first-child:before {counter-increment: q1 0;  }\n li {display: block; }\n #l24 {padding-left: 0pt;counter-reset: r1 1; }\n #l24> li>*:first-child:before {counter-increment: r1; content: counter(r1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l24> li:first-child>*:first-child:before {counter-increment: r1 0;  }\n',
        }}
      />
      <div className="text-uppercase font-900 font-bold flex justify-center text-black">
        {getLocaleString('gold_kinen_title', locale)}
      </div>
      <h1
        style={{
          paddingTop: '3pt',

          textIndent: '0pt',
          textAlign: 'center',
        }}
      >
        {getLocaleString('delivery_protocol_header', locale)}
      </h1>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}>
        <br />
      </p>

      <ul className="list-disc">
        {data.map((item, idx) => (
            <li >
              <p
                style={{
                  paddingTop: '9pt',
                  paddingLeft: '23pt',
                  textIndent: '-5pt',
                  textAlign: 'left',
                }}
              >
                  ● {item}
              </p>
            </li>
        ))}
        
        
        {/* <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            ●	Deliveries within in Dhaka will be made within 5 working days and outside Dhaka within 10 working days once “Collect Request” is initiated.{' '}
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            ●	It is user’s responsibility to provide correct and valid delivery addresses. Discrepancies and errors can lead to delays and “Collect Request” cancellation.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            ●	Once a “Collect Request” has been initiated to a specific address provided by the user, the address pertaining to the said “Collect Request” cannot be altered by the user.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            ● Users are required to check and confirm delivery address when initiating “Collect Request”.{' '}
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	Deliveries maybe conducted by “Gold Kinen” through third-party vendors.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	Delivery charges are applicable and will be borne by the user, which may vary based on the user’s nominated delivery address. 
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	During delivery, users initiating “Collect Request” will be required to provide valid NID card for inspection by the delivery person. Once the delivery person has validated the identity of the user, only then, the product will be delivered. The delivery person may ask the user for a photo to be taken during the execution of the delivery for future reference and validation purposes.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	Users must check and ensure the quantity of product as expected at the time of the delivery, in the presence of the delivery person.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	For quality assurance, certifications will be provided with each unit of product defining the weight and purity of the gold product. For any clarifications regarding the provided certifications users are requested to contact 09610964653.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	All Gold Kinen products are delivered in a tamper-proof packaging. If a package is damaged or broken at time of delivery, users must not accept the delivery, and are requested to contact Gold Kinen customer service at 09610964653 immediately.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	If a product with a broken packaging or seal is accepted by the user, Gold Kinen cannot be held liable for the quality and authenticity of the product.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	Once product has been delivered and accepted by users it cannot be returned back to Gold Kinen.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	Users are requested to thoroughly inspect and check the product at the time of delivery.
          </p>
        </li>
        <li >
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            ●	Gold Kinen users are requested to report any dispute or discrepancy at the point of delivery immediately at 09610964653 without tampering / damaging the sealed product.
          </p>
        </li> */}
      </ul>
    </div>
  );
};
